import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient()

queryClient.defaultQueryOptions({
  retry: false,
  cacheTime: 1000 * 9, // 9 minutes
})
